export default "__VITE_ASSET__DTJqwwgd__"